import { Button, Card, Grid, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/system';
import './Indicator.css';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Inds from '../../../src/Indicators.json';
import Inds2 from './Indicator2.json';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Tab, Tabs } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import { useDispatch, useSelector } from 'react-redux';
import { InputLabel } from '@mui/material';
import { fetchIndicatorData, indicatorDetails } from '../../Actions/Indicators';
import FormHelperText from '@mui/material/FormHelperText';
import axios from 'axios';

const theme = createTheme({
  breakpoints: {
    values: {
      xxs: 0,
      xs: 340,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const Indicators = () => {
  const userData = JSON.parse(localStorage.getItem('access_token'));

  const [forceRerender, setForceRerender] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchIndicatorData(userData.token));
  }, [dispatch, forceRerender]);

  const [name, setName] = React.useState();

  const handChange = event => {
    setName(event.target.value);
  };
  const [open, setOpen] = useState(false);
  const [indData, setIndData] = useState([]);
  const [scroll, setScroll] = useState('paper');
  const [content, setContent] = useState(Inds);
  const handleOpen = indicator => {
    setOpen(true);
    console.log('indicator', indicator);
    setContent(indicator);
    setIndData(indicator.indicators);
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Box>
          <Tabs width="100vw" value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab fontSize="2px" label="UWP Indicators" {...a11yProps(0)} />
            <Tab label="SDG Indicators" {...a11yProps(1)} />
            <Tab label="ADD UWP Indicators" {...a11yProps(2)} />
          </Tabs>
        </Box>

        <Box mx={{ xxs: -8, sm: -5, md: 0, lg: 0, xl: 0 }} sx={{ display: 'flex', flexGrow: 1, my: 2, width: '100vw' }}>
          <TabPanel value={value} index={0}>
            <Grid
              direction="row"
              justifyContent="center"
              container
              mx={{ xxs: -2, sm: -13, md: -20.7, lg: -18 }}
              px={{ xs: 19 }}
              spacing={{ xxs: 2, xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
            >
              {Inds.map((indicator, idx) => (
                <Grid item xs={12} sm={12} md={6} lg={4} key={idx + 1}>
                  <Card
                    width={{ sm: 4, md: 5, lg: 12 }}
                    sx={{
                      height: 'fillContent',
                      display: 'flex',
                      flexDirection: 'column',
                      p: 2,
                    }}
                    elevation="0"
                  >
                    <Typography sx={{ fontFamily: 'Sora', color: '#FF7345' }}>Goal {indicator.goal}</Typography>
                    <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '14px', my: 0.5 }}>
                      Code {indicator.code}
                    </Typography>
                    <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6 }}>
                      {indicator.code} {indicator.title}
                    </Typography>
                    <Button
                      sx={{
                        fontFamily: 'Sora',
                        color: '#FF7345',
                        display: 'flex',
                        justifyContent: 'left',
                        width: '100%',
                        marginTop: '20px',
                      }}
                      endIcon={<ArrowForwardIcon />}
                      onClick={() => handleOpen(indicator)}
                    >
                      Learn More
                    </Button>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Grid
              direction="row"
              justifyContent="center"
              container
              mx={{ xxs: -2, sm: -13, md: -20.7, lg: -18 }}
              px={{ xs: 19 }}
              spacing={{ xxs: 2, xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
            >
              {Inds2.map((indicator, idx) => (
                <Grid item xs={12} sm={12} md={6} lg={4} key={idx + 1}>
                  <Card
                    width={{ sm: 4, md: 5, lg: 12 }}
                    sx={{
                      height: 'fillContent',
                      display: 'flex',
                      flexDirection: 'column',
                      p: 2,
                    }}
                  >
                    <Typography sx={{ fontFamily: 'Sora', color: '#FF7345' }}>Goal {indicator.goal}</Typography>
                    <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '14px', my: 0.5 }}>
                      Code {indicator.code}
                    </Typography>
                    <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6 }}>
                      {indicator.code} {indicator.title}
                    </Typography>
                    <Button
                      sx={{
                        fontFamily: 'Sora',
                        color: '#FF7345',
                        display: 'flex',
                        justifyContent: 'left',
                        width: '100%',
                        marginTop: '20px',
                      }}
                      endIcon={<ArrowForwardIcon />}
                      onClick={() => handleOpen(indicator)}
                    >
                      Learn More
                    </Button>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box
              component="form"
              marginLeft={{ xxs: '10vw', sm: '0vw' }}
              sx={{
                '& > :not(style)': { m: 1 },

                width: '90vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              px={12}
              noValidate
            >
              <FormControl sx={{ minWidth: '20vw', width: '30vw' }} variant="standard">
                <InputLabel htmlFor="component">Code</InputLabel>
                <Input id="component" value={name} onChange={handChange} />
              </FormControl>
              <FormControl variant="standard">
                <InputLabel htmlFor="component">Goal</InputLabel>
                <Input sx={{ minWidth: '20vw', width: '30vw' }} id="component" value={name} onChange={handChange} />
              </FormControl>
              <FormControl variant="standard">
                <InputLabel htmlFor="component">Type</InputLabel>
                <Input sx={{ minWidth: '20vw', width: '30vw' }} id="component" value={name} onChange={handChange} />
              </FormControl>
              <FormControl variant="standard">
                <InputLabel htmlFor="component">Description</InputLabel>
                <Input sx={{ minWidth: '20vw', width: '30vw' }} id="component" value={name} onChange={handChange} />
              </FormControl>
              <FormControl variant="standard">
                <InputLabel htmlFor="component">Indicators</InputLabel>
                <Input sx={{ minWidth: '20vw', width: '30vw' }} id="component" value={name} onChange={handChange} />
              </FormControl>
              <Button variant="contained">Submit</Button>
            </Box>
          </TabPanel>
        </Box>
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title" sx={{ fontFamily: 'Sora', color: '#FF7345' }}>
          Goal {content.goal}
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            sx={{ display: 'flex', flexDirection: 'column' }}
          >
            <Typography sx={{ fontFamily: 'Sora', color: '#FF7345', fontSize: '14px', my: 0.5 }}>
              Code {content.code}
            </Typography>
            <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6, my: 0.5 }}>
              {content.code} {content.title}
            </Typography>
            <Typography sx={{ fontFamily: 'Sora', color: '#FF7345', fontSize: '14px', marginBottom: 1, marginTop: 1 }}>
              Indicators
            </Typography>
            {indData.map(data => (
              <Typography sx={{ fontFamily: 'Sora', color: '#223230', fontSize: '11px', opacity: 0.6, my: 0.5 }}>
                {data.code} {data.description}
              </Typography>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            sx={{
              fontFamily: 'Sora',
              color: '#FF7345',
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};
